module.exports = __webpack_public_path__ + "img/66a0bb6.jpg";